var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"graph"},_vm._l((_vm.bars),function(o,i){return _c('div',{key:i,staticClass:"bar",style:({
          height: ((_vm.graphH-30*(10-o.value)) + "px"),
          background: o.color[0],
          "box-shadow": ("0px 4px 40px 0px " + (o.color[1])),
        }),attrs:{"name":o.label,"value":o.valueLabel || o.value}})}))]),_c('ul',{staticClass:"legend"},_vm._l((_vm.legend),function(text,i){return _c('li',{key:i,staticClass:"legend-item"},[_c('div',{staticClass:"box",style:({
          background: _vm.bars[i].color[0],
          "box-shadow": ("0px 4px 40px 0px " + (_vm.bars[i].color[1])),
        })}),_vm._v("\n      "+_vm._s(text)+"\n    ")])}))])}
var staticRenderFns = []

export { render, staticRenderFns }